import BASE_URL from "../../shared/base-url"

export const PARKING_ACTIVITY_ENDPOINT = {
  detail: `${BASE_URL}/parking-lots/get-parking-activity`,
  list: `${BASE_URL}/parking-lots/get-parking-activities`,

  // getOwnersOfSale: `${BASE_URL}/owners/get-owners`,
  archive: `${BASE_URL}/parking-lots/archive-parking-activity`,
  delete: `${BASE_URL}/parking-lots/delete-parking-activity`,
  toggleStatus: `${BASE_URL}/parking-lots/activate-or-block-parking`,
  restore: `${BASE_URL}/parking-lots/restore-parking-activity`,
  // archivedParkingLots: `${BASE_URL}/parking-lots/get-archived-parking-activities`,
  archivedParkingActivity: `${BASE_URL}/parking-lots/get-archived-parking-activity`,
  create: `${BASE_URL}/parking-lots/create-parking-activity`,
  update: `${BASE_URL}/parking-lots/update-parking-activity`,
  calculateActivityPrice: `${BASE_URL}/parking-lots/calculate-activity-price`,





  export: `${BASE_URL}/parking-lots/export-parking-lots`,
  import: `${BASE_URL}/parking-lots/import-parking-lots`,
  removeFile: `${BASE_URL}/parking-lots/remove-image`,
}
